import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import HeroRenderer from "./Renderer";

const HeroForm = lazyLoad(() => import("./Form"));

const HeroPlugin = (settings) =>
    createPlugin({
        Renderer: HeroRenderer,
        Controls: HeroForm,
        ...settings,
    });

const Hero = HeroPlugin();
export default Hero;

export { HeroPlugin, HeroRenderer };
